import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logoblack from '../../assests/logo-black.png';
import { FaBars, FaTimes } from "react-icons/fa";
import "./index.css";

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeNav, setActiveNav] = useState("projects");
    const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);
    const [showArchitectureDropdown, setShowArchitectureDropdown] = useState(false);
    const [showResidentialDropdown, setShowResidentialDropdown] = useState(false);
    const [showInteriorDropdown, setShowInteriorDropdown] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Mobile submenu states
    const [showMobileArchitecture, setShowMobileArchitecture] = useState(false);
    const [showMobileResidential, setShowMobileResidential] = useState(false);
    const [showMobileInterior, setShowMobileInterior] = useState(false);

    const isActive = (path) => {
        return location.pathname === path;
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };



    return (
        <>
            {/* Navigation Header */}
            <header className="navbar-header">
                <div className="navbar-logo-container">
                    <Link to="/">
                        <img
                            src={logoblack}
                            alt="Logo"
                            className="navbar-logo-image"
                        />
                    </Link>
                </div>

                {/* Desktop Navigation */}
                <nav className="navbar-navigation">
                    <Link
                        to="/about"
                        className={`navbar-nav-item ${activeNav === "about" ? "navbar-active" : ""}`}
                        onMouseEnter={() => setActiveNav("about")}
                        onMouseLeave={() => setActiveNav("projects")}
                        onClick={() => {
                            setShowProjectsDropdown(false);
                            setShowArchitectureDropdown(false);
                            setShowResidentialDropdown(false);
                            setShowInteriorDropdown(false);
                        }}
                    >
                        ABOUT
                    </Link>

                    {/* PROJECTS Dropdown */}
                    <div
                        className="navbar-nav-dropdown-container"
                        onMouseEnter={() => setShowProjectsDropdown(true)}
                        onMouseLeave={() => {
                            setShowProjectsDropdown(false);
                            setShowArchitectureDropdown(false);
                            setShowResidentialDropdown(false);
                            setShowInteriorDropdown(false);
                        }}
                    >
                        <span className="navbar-nav-item navbar-nav-dropdown-trigger">
                            PROJECTS
                        </span>

                        {/* Level 1: ARCHITECTURE / INTERIOR */}
                        {showProjectsDropdown && (
                            <div className="navbar-dropdown-menu">
                                {/* ARCHITECTURE with submenu */}
                                <div
                                    className="navbar-dropdown-item navbar-has-submenu"
                                    onMouseEnter={() => {
                                        setShowArchitectureDropdown(true);
                                        setShowInteriorDropdown(false);
                                    }}
                                    onMouseLeave={() => {
                                        setShowArchitectureDropdown(false);
                                        setShowResidentialDropdown(false);
                                    }}
                                >
                                    <span>ARCHITECTURE</span>

                                    {/* Level 2: COMMERCIAL / RESIDENTIAL */}
                                    {showArchitectureDropdown && (
                                        <div className="navbar-dropdown-submenu">
                                            {/* RESIDENTIAL with submenu */}
                                            <div
                                                className="navbar-dropdown-item navbar-has-submenu"
                                                onMouseEnter={() => setShowResidentialDropdown(true)}
                                            >
                                                <span>RESIDENTIAL</span>

                                                {/* Level 3: MULTI STOREY / LOWRISE / INDEPENDENT */}
                                                {showResidentialDropdown && (
                                                    <div className="navbar-dropdown-submenu">
                                                        <div
                                                            className="navbar-dropdown-item"
                                                            onClick={() => navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'MULTI STOREY RESIDENTIALS' } })}
                                                        >
                                                            MULTI STOREY RESIDENTIALS
                                                        </div>
                                                        <div
                                                            className="navbar-dropdown-item"
                                                            onClick={() => navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'LOWRISE' } })}
                                                        >
                                                            LOWRISE
                                                        </div>
                                                        <div
                                                            className="navbar-dropdown-item"
                                                            onClick={() => navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'INDEPENDENT BUNGLOWS' } })}
                                                        >
                                                            INDEPENDENT BUNGLOWS
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* COMMERCIAL */}
                                            <div
                                                className="navbar-dropdown-item"
                                                onMouseEnter={() => setShowResidentialDropdown(false)}
                                                onClick={() => navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'COMMERCIAL' } })}
                                            >
                                                COMMERCIAL
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* INTERIOR with submenu */}
                                <div
                                    className="navbar-dropdown-item navbar-has-submenu"
                                    onMouseEnter={() => {
                                        setShowResidentialDropdown(false);
                                        setShowArchitectureDropdown(false);
                                        setShowInteriorDropdown(true);
                                    }}
                                    onMouseLeave={() => {
                                        setShowInteriorDropdown(false);
                                    }}
                                >
                                    <span>INTERIOR</span>

                                    {/* Level 2: COMMERCIAL / RESIDENTIAL */}
                                    {showInteriorDropdown && (
                                        <div className="navbar-dropdown-submenu">
                                            <div
                                                className="navbar-dropdown-item"
                                                onClick={() => navigate('/projects', { state: { projectType: 'INTERIOR', category: 'COMMERCIAL' } })}
                                            >
                                                COMMERCIAL
                                            </div>
                                            <div
                                                className="navbar-dropdown-item"
                                                onClick={() => navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'RESIDENTIAL INTERIORS' } })}
                                            >
                                                RESIDENTIAL
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <Link
                        to="/scope"
                        className={`navbar-nav-item ${activeNav === "services" ? "navbar-active" : ""}`}
                        onMouseEnter={() => setActiveNav("services")}
                        onMouseLeave={() => setActiveNav("projects")}
                        onClick={() => {
                            setShowProjectsDropdown(false);
                            setShowArchitectureDropdown(false);
                            setShowResidentialDropdown(false);
                            setShowInteriorDropdown(false);
                        }}
                    >
                        SCOPE
                    </Link>
                    <Link
                        to="/contact"
                        className={`navbar-nav-item ${activeNav === "contact" ? "navbar-active" : ""}`}
                        onMouseEnter={() => setActiveNav("contact")}
                        onMouseLeave={() => setActiveNav("projects")}
                        onClick={() => {
                            setShowProjectsDropdown(false);
                            setShowArchitectureDropdown(false);
                            setShowResidentialDropdown(false);
                            setShowInteriorDropdown(false);
                        }}
                    >
                        CONTACT
                    </Link>
                </nav>

                {/* Hamburger Menu Icon (Mobile Only) */}
                <button className="navbar-hamburger-icon" onClick={toggleMobileMenu}>
                    {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </header>

            {/* Mobile Menu Overlay */}
            <div
                className={`navbar-mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={closeMobileMenu}
            ></div>

            {/* Mobile Navigation Menu */}
            <nav className={`navbar-mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="navbar-mobile-nav-header">
                    <img src={logoblack} alt="Logo" className="navbar-mobile-nav-logo" />
                    <button className="navbar-mobile-close-btn" onClick={closeMobileMenu}>
                        <FaTimes />
                    </button>
                </div>

                <div className="navbar-mobile-nav-links">
                    <Link
                        to="/about"
                        className={`navbar-mobile-nav-item ${isActive('/about') ? 'navbar-mobile-active' : ''}`}
                        onClick={closeMobileMenu}
                    >
                        ABOUT
                    </Link>


                    {/* Mobile Projects with Expandable Sub-items */}
                    <div className="navbar-mobile-nav-item-wrapper">
                        <div className={`navbar-mobile-nav-item ${isActive('/projects') ? 'navbar-mobile-active' : ''}`}>
                            PROJECTS
                        </div>
                        <div className="navbar-mobile-nav-subitems">
                            {/* Architecture with expandable submenu */}
                            <div className="navbar-mobile-submenu-wrapper">
                                <div
                                    className="navbar-mobile-nav-subitem"
                                    onClick={() => setShowMobileArchitecture(!showMobileArchitecture)}
                                >
                                    ARCHITECTURE {showMobileArchitecture ? '▼' : '▶'}
                                </div>
                                {showMobileArchitecture && (
                                    <div className="navbar-mobile-nav-sub-subitems">
                                        {/* Commercial */}
                                        <div
                                            className="navbar-mobile-nav-sub-subitem"
                                            onClick={() => {
                                                navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'COMMERCIAL' } });
                                                closeMobileMenu();
                                            }}
                                        >
                                            COMMERCIAL
                                        </div>
                                        {/* Residential with expandable submenu */}
                                        <div className="navbar-mobile-submenu-wrapper">
                                            <div
                                                className="navbar-mobile-nav-sub-subitem"
                                                onClick={() => setShowMobileResidential(!showMobileResidential)}
                                            >
                                                RESIDENTIAL {showMobileResidential ? '▼' : '▶'}
                                            </div>
                                            {showMobileResidential && (
                                                <div className="navbar-mobile-nav-sub-sub-subitems">
                                                    <div
                                                        className="navbar-mobile-nav-sub-sub-subitem"
                                                        onClick={() => {
                                                            navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'MULTI STOREY RESIDENTIALS' } });
                                                            closeMobileMenu();
                                                        }}
                                                    >
                                                        MULTI STOREY RESIDENTIALS
                                                    </div>
                                                    <div
                                                        className="navbar-mobile-nav-sub-sub-subitem"
                                                        onClick={() => {
                                                            navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'LOWRISE' } });
                                                            closeMobileMenu();
                                                        }}
                                                    >
                                                        LOWRISE
                                                    </div>
                                                    <div
                                                        className="navbar-mobile-nav-sub-sub-subitem"
                                                        onClick={() => {
                                                            navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'INDEPENDENT BUNGLOWS' } });
                                                            closeMobileMenu();
                                                        }}
                                                    >
                                                        INDEPENDENT BUNGLOWS
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {/* Interior with expandable submenu */}
                            <div className="navbar-mobile-submenu-wrapper">
                                <div
                                    className="navbar-mobile-nav-subitem"
                                    onClick={() => setShowMobileInterior(!showMobileInterior)}
                                >
                                    INTERIOR {showMobileInterior ? '▼' : '▶'}
                                </div>
                                {showMobileInterior && (
                                    <div className="navbar-mobile-nav-sub-subitems">
                                        <div
                                            className="navbar-mobile-nav-sub-subitem"
                                            onClick={() => {
                                                navigate('/projects', { state: { projectType: 'INTERIOR', category: 'COMMERCIAL' } });
                                                closeMobileMenu();
                                            }}
                                        >
                                            COMMERCIAL INTERIOR
                                        </div>
                                        <div
                                            className="navbar-mobile-nav-sub-subitem"
                                            onClick={() => {
                                                navigate('/projects', { state: { projectType: 'ARCHITECTURE', category: 'RESIDENTIAL', subCategory: 'RESIDENTIAL INTERIORS' } });
                                                closeMobileMenu();
                                            }}
                                        >
                                            RESIDENTIAL INTERIOR
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <Link
                        to="/scope"
                        className={`navbar-mobile-nav-item ${isActive('/scope') ? 'navbar-mobile-active' : ''}`}
                        onClick={closeMobileMenu}
                    >
                        SCOPE
                    </Link>
                    <Link
                        to="/contact"
                        className={`navbar-mobile-nav-item ${isActive('/contact') ? 'navbar-mobile-active' : ''}`}
                        onClick={closeMobileMenu}
                    >
                        CONTACT
                    </Link>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
